@if (widget().workflowId) {
  <mat-tab-group animationDuration="0ms" color="transparent" disablePagination>
    <mat-tab label="{{ 'Details' | transloco }}">
      <tt-divider class="tt-guideline-sidebar_divider" />

      <div class="tt-guideline-workflow-sidebar-wrapper_details">
        <div class="tt-guideline-workflow-sidebar-wrapper_details-info">
          <app-key-value [key]="'WorkflowSidebar.Title' | transloco" [value]="widget().workflowTitle" />
          <app-key-value [key]="'WorkflowSidebar.Version' | transloco" [value]="widget().workflowVersion" />
        </div>

        <div class="tt-guideline-workflow-sidebar-wrapper_details-button">
          <button ttButton [emphasis]="'minimal'" [variant]="'destructive'" (click)="resetWorkflowWidget()">
            <mat-icon [icon]="'x'" [iconSize]="16" />
            <span>{{ 'WorkflowSidebar.RemoveWorkflow' | transloco }}</span>
          </button>
        </div>
      </div>
    </mat-tab>
  </mat-tab-group>
} @else {
  <shared-sidebar-placeholder />
}
